export default {
  smart_rede: "Rede",
  stone: "Stone",
  stonepos: "Stone POS",
  cielo: "cielo",
  pagseguro: "pagSeguro",
  sumup: "SumUp",
  getnet: "Getnet",
  mercado_pago: "Mercado Pago"
};



// WEBPACK FOOTER //
// ./src/core/enum/acquirer-names.enum.js